import { WidgetProps } from '@rjsf/core';
import React from 'react';
import { useSelector } from 'react-redux';
import { StateShape as ReduxStateShape } from '../../reducers';

const PaletteSelect = (props: WidgetProps) => {
    const { label, value, onChange } = props;

    const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        e.preventDefault();
        onChange(e.target?.value);
    };

    const { colorPalettes } = useSelector((state: ReduxStateShape) => ({
        ...state?.themes,
    }));

    const paletteOptions = colorPalettes && Object.keys(colorPalettes);

    return (
        <div className="custom-select">
            <label className="select-label">{label}</label>
            <select className="custom-select-input" onChange={handleChange} defaultValue={value}>
                {paletteOptions?.map((key: string, i: number) => (
                    <option key={`${key}-${i}`} id={key} value={key}>
                        {key}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default PaletteSelect;
